<template>
    <Head title="Dashboard: Пул адресов"/>

    <authenticated-layout :notifications="notifications" >

        <v-navigation />

        <div class="flex flex-col bg-white p-4" v-if="statistics.usersBalances">
            <div class="flex justify-between items-baseline">
                <h1 class="text-lg pb-4">Балансы пула адресов</h1>
                <v-button color="green" @click="unloadBalances">Выгрузить</v-button>
            </div>
            <div class="grid grid-cols-9 gap-2 border-b">
                <strong class="col-span-3">Адрес</strong>
                <strong class="text-center">Сеть</strong>
                <strong class="text-center">Монета</strong>
                <strong>Тип</strong>
                <strong>Пользователь</strong>
                <strong class="col-span-2 text-right">Баланс</strong>
            </div>
            <div
                class="grid grid-cols-9 p-1 gap-2"
                :class="{'bg-gray-100': index%2}"
                v-for="(row, index) of statistics.usersBalances"
            >
                <strong class="col-span-3 truncate" :title="row.address">{{ row.address }}</strong>
                <span class="text-center">{{ row.network }}</span>
                <span class="text-center">{{ row.currency }}</span>
                <span>{{ row.type }}</span>
                <span v-if="row.user">
                    <Link class="text-blue-700" :href="this.route('ocp.user', row.user.id)">{{ row.user.email }}</Link>
                </span>
                <span v-else>{{ row.user }}</span>
                <span class="col-span-2 text-right">{{ row.user_balance }}</span>
            </div>
        </div>

    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/Dashboard';
import VButton from '@/Components/Button';

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        VNavigation,
        VButton,
    },
    props: {
        success: Boolean,
        statistics: Object,
        notifications: Array,
    },
    methods: {
        unloadBalances(){
            useForm({}).post(this.route('ocp.statistics.unload-balances'))
        },
    },
}
</script>
